import React from "react";
import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
import OptionList from "@JohnLewisPartnership/jl-design-system/dist/components/option/OptionList";
import RadioButton from "@JohnLewisPartnership/jl-design-system/dist/components/radio-button/RadioButton";
import { Select } from "@JohnLewisPartnership/jl-design-system/dist/components/select/Select";
import styles from "./styles.module.scss";

const Element = ({ element, responses, handleChange }) => {
  const elementId = element.id;
  const onChange = event => {
    const { name, value } = event.target;
    handleChange(name, value);
  };

  switch (element.type) {
    case "radio":
      return (
        <div className={styles.radioGroupWrapper}>
          <div className={styles.labelContainer}>
            <div className={element.description !== "" ? styles.wrapper : ""}>
              <div className={styles.title}>{element.title}</div>
              {typeof element.description === "function" ? (
                <div>{element.description()}</div>
              ) : (
                <div className={styles.description}>{element.description}</div>
              )}
            </div>
          </div>
          <OptionList name={element.id} isControlled>
            {element.options.map(option => (
              <RadioButton
                key={option.value}
                value={option.value}
                label={option.label}
                onChange={onChange}
                checked={responses[element.id] === option.value}
                className={element.inlineOptions ? styles.inlineElement : ""}
              >
                {option.supportingLabel && <span className={styles.supportingLabel}>{option.supportingLabel}</span>}
              </RadioButton>
            ))}
          </OptionList>
        </div>
      );
    case "select":
      return (
        <div className={styles.fieldWrapper}>
          <div className={styles.labelContainer}>
            <div className={element.description !== "" ? styles.wrapper : ""}>
              <div className={styles.title}>{element.title}</div>
              <div className={styles.description}>{element.description}</div>
            </div>
          </div>
          <Select
            id={element.id}
            name={element.id}
            onChange={onChange}
            className={styles.select}
            value={responses[elementId] || ""}
          >
            {element.options
              .map(option => ({
                value: option.value,
                label: option.label,
              }))
              .map(({ value, label }) => (
                <option value={value} key={value}>
                  {label}
                </option>
              ))}
          </Select>
        </div>
      );
    case "message":
      return <Message {...element.componentProps} />;
    default:
      return null;
  }
};

export default Element;
